import { firestoreAction } from 'vuexfire'
import {db} from '@/firebase'

const clients = db.collection('clients')
const products = db.collection('products')
const contacts = db.collection('contacts')
const client_img = db.collection('client_img')
const client_info = db.collection('client_info')
const client_fin = db.collection('client_fin')

const state = {
  client: [],
  clients: [],
  products: [],
  contacts: [],
  client_img: [],
  client_info: [],
  client_fin: [] 
}

const getters = {
  cli: state => (
    state.client[0] ? state.client[0] : {}
  ),
  clim: state => (
    state.clients[0] ? state.clients[0] : {}
  )
}

const actions = {
  initClient: firestoreAction(({ bindFirestoreRef }, slug) => {
    bindFirestoreRef('client', db.collection('client').where('slug', '==', slug))
  }),
  initClientm: firestoreAction(({ bindFirestoreRef }, slug) => {
    bindFirestoreRef('clients', db.collection('clients').where('slug', '==', slug))
  }),
  initClients: firestoreAction(({ bindFirestoreRef }, Cli_id) => {
    bindFirestoreRef('clients', clients.where('Cli_id', '==', Cli_id))
  }),
  initContacts: firestoreAction(({ bindFirestoreRef }, client_id) => {
    bindFirestoreRef('contacts', contacts.where('client_id', '==', client_id))
  }),
  initClientImg: firestoreAction(({ bindFirestoreRef }, client_id) => {
    bindFirestoreRef('client_img', client_img.where('client_id', '==', client_id))
  }),
  initClientInfo: firestoreAction(({ bindFirestoreRef }, client_id) => {
    bindFirestoreRef('client_info', client_info.where('client_id', '==', client_id))
  }),
  initClientFin: firestoreAction(({ bindFirestoreRef }, client_id) => {
    bindFirestoreRef('client_fin', client_fin.where('client_id', '==', client_id))
  }),
  initProduct: firestoreAction(({ bindFirestoreRef }, client_slug) => {
    bindFirestoreRef('products', products.where('client_slug', '==', client_slug))
  })
}

export default {
  namespaced: true,
  state,
  actions,
  getters
}

